// extracted by mini-css-extract-plugin
export var layoutContainer = "_d7-0";
export var layoutContainerNoRounding = "_d7-6";
export var layoutContainerOpen = "_d7-5";
export var layoutContainerResizing = "_d7-1";
export var mainContent = "_d7-2";
export var resizeDivider = "_d7-3";
export var slidePanel = "_d7-4";